import { useTranslation } from 'react-i18next'
import { Clock, Instagram, Phone, Send } from 'lucide-react'
import { CONTACT } from '@/data/contact'

/**
 * Shown in place of the lead form while LEAD_FORM_ENABLED is false.
 * Every channel here is a real, reachable one.
 */
export function ContactDetails() {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-3">
      {/* Phone — the primary action, tappable on mobile */}
      <a
        href={CONTACT.phone.href}
        className="group flex items-center gap-4 rounded-xl border border-primary/25 bg-primary/[0.06] p-4 transition-colors hover:border-primary/50 hover:bg-primary/10"
      >
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary text-white shadow-sm">
          <Phone className="h-[18px] w-[18px]" />
        </span>
        <span className="min-w-0">
          <span className="block text-[11px] font-semibold uppercase tracking-[0.1em] text-primary">
            {t('contact.call')}
          </span>
          <span className="mt-0.5 block text-[19px] font-bold tracking-tight text-foreground">
            {CONTACT.phone.display}
          </span>
        </span>
      </a>

      {/* Messaging channels */}
      <div className="grid grid-cols-2 gap-3">
        <a
          href={CONTACT.telegram.href}
          target="_blank"
          rel="noopener noreferrer"
          className="group flex flex-col gap-2 rounded-xl border border-foreground/10 p-4 transition-colors hover:border-[#0088cc]/50 hover:bg-[#0088cc]/[0.06]"
        >
          <Send className="h-[18px] w-[18px] text-[#0088cc] transition-transform group-hover:-rotate-12" />
          <span>
            <span className="block text-[13px] font-semibold text-foreground">
              {t('contact.telegram_label')}
            </span>
            <span className="block text-[12px] text-foreground/45">{CONTACT.telegram.handle}</span>
          </span>
        </a>

        <a
          href={CONTACT.instagram.href}
          target="_blank"
          rel="noopener noreferrer"
          className="group flex flex-col gap-2 rounded-xl border border-foreground/10 p-4 transition-colors hover:border-[#DD2A7B]/50 hover:bg-[#DD2A7B]/[0.06]"
        >
          <Instagram className="h-[18px] w-[18px] text-[#DD2A7B] transition-transform group-hover:scale-110" />
          <span>
            <span className="block text-[13px] font-semibold text-foreground">
              {t('contact.instagram_label')}
            </span>
            <span className="block text-[12px] text-foreground/45">{CONTACT.instagram.handle}</span>
          </span>
        </a>
      </div>

      {/* Working hours */}
      <div className="flex items-center gap-2.5 rounded-xl bg-[#F8FAFC] px-4 py-3">
        <Clock className="h-4 w-4 shrink-0 text-foreground/35" />
        <span className="text-[13px] text-foreground/60">
          <span className="font-medium text-foreground/75">{t('contact.hours_label')}:</span>{' '}
          {t('contact.hours')}
        </span>
      </div>
    </div>
  )
}
